module.exports = __webpack_public_path__ + "static/media/MaisAcessoNew.07ef8779.svg";